import { useState } from "react";
import { Check, Copy, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const InviteLinkBox = ({ token, email }) => {
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/undangan#t=${token}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Tautan undangan disalin.");
    } catch {
      toast.error("Gagal menyalin. Salin tautan secara manual.");
    }
  };
  return (
    <div className="rounded-xl border-2 border-[#3B82F6] bg-blue-50/60 dark:bg-blue-950/30 p-4 space-y-3 sist-rise" data-testid="invite-link-box">
      <div className="flex items-center gap-2 font-semibold"><KeyRound className="h-4 w-4 text-[#3B82F6]" /> Tautan undangan untuk {email}</div>
      <p className="text-xs text-muted-foreground">
        Tautan ini hanya ditampilkan sekali dan berlaku satu kali pakai. Bagikan secara pribadi kepada penerima. Tidak ada kata sandi bawaan.
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input readOnly value={link} className="flex-1 rounded-md border bg-background px-3 py-2 text-xs font-mono" aria-label="Tautan undangan" data-testid="invite-link-input" />
        <Button onClick={copy} data-testid="invite-link-copy-button">
          {copied ? <Check className="h-4 w-4 mr-1" /> : <Copy className="h-4 w-4 mr-1" />} {copied ? "Tersalin" : "Salin tautan"}
        </Button>
      </div>
    </div>
  );
};
